/**
 * Degraded Mode Toast
 *
 * Shows a non-intrusive notification when fds-id server is unavailable.
 * Core functionality continues to work - this just informs the user.
 */

import { Toast } from './ui/Toast'
import { useDegradedMode } from '../hooks'

export function DegradedModeToast() {
  const { showNotification, dismissNotification } = useDegradedMode()

  return (
    <Toast
      visible={showNotification}
      message="Some features temporarily unavailable"
      description="Core functionality is unaffected"
      type="info"
      duration={5000}
      onDismiss={dismissNotification}
    />
  )
}

export default DegradedModeToast
